/* roots-quiz loader: fetch chunk assets, reassemble, inject */
(function(){
  var cfg=document.querySelector("[data-qz-assets]");
  if(!cfg) return;
  var a; try{a=JSON.parse(cfg.textContent);}catch(e){return;}
  function grab(urls){return Promise.all(urls.map(function(u){return fetch(u).then(function(r){return r.text();});}));}
  grab(a.css||[]).then(function(parts){
    var st=document.createElement("style");st.setAttribute("data-qz-style","");st.textContent=parts.join("");document.head.appendChild(st);
    return grab(a.js||[]);
  }).then(function(parts){
    var sc=document.createElement("script");sc.textContent=parts.join("");document.head.appendChild(sc);
  });
})();
